import {observer} from "mobx-react";
import {FieldInput, FieldSelect, FormSection} from "../../ui";
import {PrinterTypeDto} from "../../../api/pms";

export interface PmsFormData {
    type?: PrinterTypeDto
    displayName?: string
    name?: string
}

export interface PmsFormValidation {
    type?: string
    displayName?: string
    name?: string
}

interface PmsFormProps {
    validation: PmsFormValidation
    data: PmsFormData
    onBlur: () => any
    onChange: (value: PmsFormData) => any
}

const PmsForm = observer(function PmsForm({
                                              data,
                                              validation,
                                              onBlur,
                                              onChange,
                                          }: PmsFormProps) {
    const {
        type, displayName, name
    } = data

    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            <FormSection
                label={"Allgemein"}
                children={
                    <>
                        <div className={"columns"}>
                            <div className={"column is-one-third"}>
                                <FieldInput
                                    label={'Kurzname'}
                                    value={displayName || ''}
                                    help={validation.displayName}
                                    onBlur={() => onBlur()}
                                    onChange={v => {
                                        onChange({
                                            ...data,
                                            displayName: v
                                        })
                                    }}
                                />
                            </div>
                            <div className={"column is-one-third"}>
                                <FieldInput
                                    label={'Netzwerkname'}
                                    value={name || ''}
                                    help={validation.name}
                                    onBlur={() => onBlur()}
                                    onChange={v => {
                                        onChange({
                                            ...data,
                                            name: v
                                        })
                                    }}
                                />
                            </div>
                            <div className={"column is-one-third"}>
                                <FieldSelect
                                    options={[
                                        {
                                            value: PrinterTypeDto.DOCUMENT,
                                            label: 'Dokumente'
                                        },
                                        {
                                            value: PrinterTypeDto.ZEBRA,
                                            label: 'Zebra Label'
                                        },
                                        {
                                            value: PrinterTypeDto.VLOG,
                                            label: 'Versandlabel (VLOG)'
                                        },
                                    ]}
                                    label={'Nutzungsart'}
                                    value={type || ''}
                                    help={validation.type}
                                    onBlur={() => onBlur()}
                                    onChange={v => {
                                        onChange({
                                            ...data,
                                            type: v as PrinterTypeDto
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </>
                }
            />
        </div>
    </>
})

export {
    PmsForm
}
